import { render } from "./DocumentsModal.vue?vue&type=template&id=3b2cc685&scoped=true"
import script from "./DocumentsModal.vue?vue&type=script&lang=js"
export * from "./DocumentsModal.vue?vue&type=script&lang=js"

import "./DocumentsModal.vue?vue&type=style&index=0&id=3b2cc685&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2cc685"],['__file',"src/components/DocumentsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b2cc685"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b2cc685', __exports__)) {
    api.reload('3b2cc685', __exports__)
  }
  
  module.hot.accept("./DocumentsModal.vue?vue&type=template&id=3b2cc685&scoped=true", () => {
    api.rerender('3b2cc685', render)
  })

}


export default __exports__